import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { HdContentLanguageService } from '../bodygraph/hd-content-language.service';
import { HdGateInfoService } from '../bodygraph/hd-gate-info.service';

/**
 * Klein uitleg-paneel bij de "Extra fixed stars"-titel: waarom een nauwe
 * samenstand van een planeetactivatie met een van de 66 sterren waarde kan
 * hebben, en waarom dat níet de eigenlijke HD-fixed-star (design-noordknoop)
 * vervangt. Teksten uit de `human-design/fixed-stars`-scope
 * (`panel.extrasInfo.*`), content-taal met NL-fallback.
 */
@Component({
  selector: 'hd-fixed-stars-extras-info',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section class="fixed-stars-extras-info">
      <h3 class="fixed-stars-extras-info__title">{{ title() }}</h3>
      @for (paragraph of paragraphs(); track $index) {
        <p class="fixed-stars-extras-info__paragraph">{{ paragraph }}</p>
      }
    </section>
  `,
  styles: `
    .fixed-stars-extras-info {
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding: 14px 16px 18px;
      max-width: min(440px, 88vw);
      color: #3d414e;
    }

    .fixed-stars-extras-info__title {
      margin: 0;
      font-family: 'Bw Modelica', 'Raleway', sans-serif;
      font-weight: 900;
      font-size: 17px;
    }

    .fixed-stars-extras-info__paragraph {
      margin: 0;
      font-size: 12.5px;
      line-height: 1.5;
    }
  `,
})
export class HdFixedStarsExtrasInfoComponent {
  private readonly gateInfo = inject(HdGateInfoService);
  private readonly contentLang = inject(HdContentLanguageService);

  constructor() {
    this.gateInfo.loadScopesForLang('nl');
    this.gateInfo.loadScopesForLang('en');
  }

  protected readonly title = computed(() => this.text('panel.extrasInfo.title'));

  protected readonly paragraphs = computed(() => {
    const lang = this.contentLang.effectiveLang();
    const value = this.gateInfo.cheatSheetListIn('fixedStars', 'panel.extrasInfo.paragraphs', lang);
    if (value.length > 0 || lang === 'nl') {
      return value;
    }
    return this.gateInfo.cheatSheetListIn('fixedStars', 'panel.extrasInfo.paragraphs', 'nl');
  });

  private text(key: string): string {
    const lang = this.contentLang.effectiveLang();
    const value = this.gateInfo.cheatSheetTextIn('fixedStars', key, lang);
    if (value !== '' || lang === 'nl') {
      return value;
    }
    return this.gateInfo.cheatSheetTextIn('fixedStars', key, 'nl');
  }
}
